// The sidebar menu as data: sections, entries (hubs) and their screens. Read by the shell and by the tutorials'
// coverage test (every entry must have a guided tour), so it imports nothing with side effects.
import type { t } from '../i18n/index.js';

export type NavId = keyof typeof t.shell.nav;
export type HubId = keyof typeof t.shell.hubs;
/** Menu section: one or more neighbouring screens. With several, they show as tabs at the top of the page. */
export interface Hub {
  id: NavId | HubId; icon: string; tabs: readonly (readonly [path: string, nav: NavId])[];
  /** Screens outside the tabs that still belong here: they light up the entry and its first tab (a room belongs to Play). */
  also?: readonly string[];
}
/** Menu grouped by sections: few entries, neighbouring screens grouped into tabs. */
export const SECTIONS: readonly { id: keyof typeof t.shell.sections | ''; hubs: readonly Hub[] }[] = [
  { id: '', hubs: [{ id: 'home', icon: 'home', tabs: [['/', 'home']] }] },
  { id: 'ride', hubs: [
    { id: 'play', icon: 'flag', tabs: [['/play', 'play'], ['/events', 'events'], ['/challenges', 'challenges']], also: ['online'] },
    { id: 'training', icon: 'activity', tabs: [['/training', 'training']] },
  ] },
  { id: 'me', hubs: [
    { id: 'journal', icon: 'chart', tabs: [['/activities', 'activities'], ['/progress', 'progress']] },
    { id: 'wardrobe', icon: 'shirt', tabs: [['/wardrobe', 'wardrobe']] },
    { id: 'store', icon: 'library', tabs: [['/store', 'store']] },
    { id: 'community', icon: 'users', tabs: [['/friends', 'friends'], ['/club', 'club'], ['/leaderboards', 'leaderboards']] },
  ] },
  { id: 'create', hubs: [{ id: 'workshop', icon: 'sparkles', tabs: [['/workshop', 'workshop']] }] },
];
export const SETTINGS: Hub = { id: 'settings', icon: 'settings', tabs: [['/settings', 'settings']] };
export const TUTORIALS: Hub = { id: 'tutorials', icon: 'cap', tabs: [['/tutorials', 'tutorials']] };
export const HUBS: readonly Hub[] = [...SECTIONS.flatMap(s => s.hubs), TUTORIALS, SETTINGS];
